module.exports = __webpack_public_path__ + "img/bg111.03276ea6.png";